import { render, staticRenderFns } from "./DialogInscricao.vue?vue&type=template&id=b57c2250&scoped=true"
import script from "./DialogInscricao.vue?vue&type=script&lang=js"
export * from "./DialogInscricao.vue?vue&type=script&lang=js"
import style0 from "./DialogInscricao.vue?vue&type=style&index=0&id=b57c2250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c2250",
  null
  
)

export default component.exports